import Axios from 'axios';

export const getVersion = () => Axios.get('administration/GetVersion');